module.exports = __webpack_public_path__ + "media/site/images/icons/gear-icon-93d0abd33379d5908221bf066ff71486.svg";